import { Injectable } from '@angular/core';
import {
  CanActivate,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { UserStore } from './user.store';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(public userStore: UserStore, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    const isAuthenticated = this.userStore.isAuthenticated();
    if (!isAuthenticated) {
      const url = window.location;
      if (url.hash && url.hash.length > 1) {
        const fragment = url.hash.substr(1);
        const params = { fragment };
        this.router.navigate([`auth/login`], params);
      } else {
        this.router.navigate([`auth/login`], {
          queryParams: { returnUrl: state.url },
        });
      }
    }
    return new Promise((resolve, reject) => resolve(isAuthenticated));
  }
}
